((Drupal, once) => {
  Drupal.behaviors.loadAccountMenu = {
    attach: function () {
      once("account-menu-toggle", ".account-menu-toggle").forEach((element) => {
        element.addEventListener("click", () => {
          let [menu] = once("load-user-account-menu", "#user-account-menu");

          if (menu) {
            var endpoint = Drupal.url("dashboard/account-menu/get");
            Drupal.ajax({ url: endpoint }).execute();
          }
        });
      });
    },
  };
})(Drupal, once);
